module.exports = __webpack_public_path__ + "37f6bf9e8485a83cb3163560589d60b1.png";